import React, { useState, useContext, useEffect } from "react";

import SessionTypesTable from "components/PageDashboard/SessionTypesSection/SessionTypesTable";
import { DashboardContext } from "components/PageDashboard/PageDashboard";
import { useSendData } from "hooks/useSendData";
import { useSessionTypes } from "hooks/useSessionTypes";
import { saveSessionTypes as sst } from "api/saveSessionTypes";
import { AuthContext } from "components/AuthProvider/AuthProvider";
import { useOnEditTable } from "components/PageDashboard/useOnEditTable";

const SessionTypesSection: React.FunctionComponent = () => {
	const [{ isSignedIn, uid }] = useContext(AuthContext);

	const [dashboardContextState, setDashboardContextState] = useContext(
		DashboardContext
	);

	const {
		isWaiting,
		isLoading,
		isError,
		output: sessionTypes
	} = useSessionTypes({
		mentorId: uid,
		showDisabled: true,
		doWait: isSignedIn === undefined || !uid,
		repeatNumber: dashboardContextState.sessionTypesRefreshNum,
		persistBetweenLoads: true
	});

	const [waitModalIsShowing, setWaitModalIsShowing] = useState(false);
	const [waitModalTitle, setWaitModalTitle] = useState("");
	const saveSessionTypes = useSendData({ method: sst });

	const haveSessionTypes =
		sessionTypes === undefined ? undefined : sessionTypes.page.length !== 0;

	useEffect(() => {
		setDashboardContextState(oldState => ({ ...oldState, haveSessionTypes }));
	}, [haveSessionTypes, setDashboardContextState]);

	const onEditSessionTypes = useOnEditTable({
		setWaitModalTitle,
		setWaitModalIsShowing,
		onSaved: () => {
			setDashboardContextState(oldState => ({
				...oldState,
				sessionTypesRefreshNum: oldState.sessionTypesRefreshNum + 1
			}));
		},
		saveData: saveSessionTypes
	});

	// TODO:WV:20201009:Get the user started, maybe by asking for price during onboarding and / or adding a tutorial / walkthrough of how to set them up
	return (
		<SessionTypesTable
			onEdit={onEditSessionTypes}
			sessionTypes={sessionTypes ? sessionTypes.page : []}
			isLoading={isLoading}
			isWaiting={isWaiting || !sessionTypes}
			isError={isError}
			waitModalTitle={waitModalTitle}
			waitModalIsShowing={waitModalIsShowing}
		/>
	);
};

export default SessionTypesSection;
